import * as _ from 'lodash';
import map from '~/assets/images/map.png';
import shape1 from '~/assets/images/shape1.png';
import shape2 from '~/assets/images/shape2.svg';
import {get, isMarkdown, toHTML} from '~/utils';
import * as marked from 'marked';
import {renderMarkDown} from '~/lib/utils';

const Footer = ({footer, meta}: {footer: any; meta: any}) => {
  return (
    <>
      <footer className="footer-area bg-f7fafd">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="single-footer-widget">
                <div
                  dangerouslySetInnerHTML={{
                    __html: isMarkdown(get(footer, 'widget_1'))
                      ? renderMarkDown(get(footer, 'widget_1'))
                      : toHTML(get(footer, 'widget_1')),
                  }}
                  className="prose dark:prose-invert "
                />
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="single-footer-widget pl-5">
                <div
                  dangerouslySetInnerHTML={{
                    __html: isMarkdown(get(footer, 'widget_2'))
                      ? renderMarkDown(get(footer, 'widget_2'))
                      : toHTML(get(footer, 'widget_2')),
                  }}
                  className="prose dark:prose-invert "
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="single-footer-widget pl-5">
                <div
                  dangerouslySetInnerHTML={{
                    __html: isMarkdown(get(footer, 'widget_3'))
                      ? renderMarkDown(get(footer, 'widget_3'))
                      : toHTML(get(footer, 'widget_3')),
                  }}
                  className="prose dark:prose-invert "
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="single-footer-widget pl-5">
                <div
                  dangerouslySetInnerHTML={{
                    __html: isMarkdown(get(footer, 'widget_4'))
                      ? renderMarkDown(get(footer, 'widget_4'))
                      : toHTML(get(footer, 'widget_4')),
                  }}
                  className="prose dark:prose-invert "
                />
              </div>
            </div>

            <div className="col-lg-12 col-md-12">
              <div className="copyright-area">
                <p>{get(meta, 'copyright')}</p>
              </div>
            </div>
          </div>
        </div>

        <img src={map} className="map" alt="map" />

        {/* Shape Images */}
        <div className="shape1">
          <img src={shape1} alt="shape" />
        </div>
        <div className="shape8 rotateme">
          <img src={shape2} alt="shape" />
        </div>
      </footer>
    </>
  );
};

export default Footer;
